import type { Release } from '../releases';

export default {
  id: '2026-11-04-site-extra-work-resources',
  at: '2026-11-04T13:38:00Z',
  title: 'Акт допработ: люди, техника и материалы строками, акт в «Ждёт меня»',
  modules: ['site', 'changes'],
  items: [
    'В акте на дополнительные работы прораб указывает людей по профессиям с человеко-часами, технику проекта с машино-часами и материалы со склада проекта с количеством.',
    'Заказчик и технадзор видят акт, который ждёт их подписи, в «Ждёт меня»; прораб видит там свой акт, возвращённый с замечанием.',
    'Если после открытия акта в нём поменяли людей, технику или материалы, подпись старой версии не пройдёт — нужно обновить страницу и проверить акт заново.',
  ],
  why: 'Заказчик подписывал текст, по которому нельзя было сверить технику и материалы, а об акте на подпись узнавали со слов. Теперь акт сверяется со справочниками и сам приходит тому, кто должен его подписать.',
  link: '/site/extra-works',
} satisfies Release;
